module.exports = __webpack_public_path__ + "static/media/girl.cd63945d.svg";